import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { SmartImage } from 'components/global/SmartImage';
import { RICH_TEXT_OPTIONS } from 'consts/contentful';
import type { ProductsEntry } from 'schema';

import { SqueezeRedesignProducts } from '.';
import { SubsectionProps } from './components';
import { ECOM_PRODUCTS_MODULE } from './content/ecomProductsModule';
import { RX_PRODUCTS_MODULE } from './content/rxProductsModule';

const subscriptionMapping: { [key: string]: SubsectionProps } = {
  'Rx Formulas': RX_PRODUCTS_MODULE,
  'Ecom Products': ECOM_PRODUCTS_MODULE,
};

export const ContentfulProducts = ({
  valueProps,
  productSubsections,
  ...props
}: ProductsEntry) => (
  <SqueezeRedesignProducts
    {...props}
    headerCells={valueProps}
    products={(productSubsections ?? []).map(
      ({
        header: subsectionHeader,
        body,
        ctaText,
        media,
        imageCaption,
        subsectionType,
        productCardCtaText,
      }) => ({
        ...subscriptionMapping[subsectionType],
        title: subsectionHeader,
        subtitle: body && documentToReactComponents(body, RICH_TEXT_OPTIONS),
        ctaButtonText: ctaText,
        productCardCtaText: productCardCtaText,
        accentImage: media && {
          image: {
            desktop: <SmartImage {...media} />,
            mobile: <SmartImage {...media} />,
          },
          name: imageCaption,
        },
      }),
    )}
    {...props}
  />
);
